// src/pages/CookiesPage.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const CookiesPage = () => {
  const { t } = useTranslation();

  return (
    <main className="mx-auto max-w-3xl px-4 py-10 text-sm text-slate-800 sm:px-6 lg:px-8">

      <h1 className="text-2xl font-semibold text-slate-900 sm:text-3xl">
        {t("legal.cookies.title")}
      </h1>

      <p className="mt-2 text-[12px] text-slate-500">
        {t("legal.lastUpdated", { year: new Date().getFullYear() })}
      </p>

      <p className="mt-6 text-[13px] leading-relaxed">
        {t("legal.cookies.intro")}
      </p>

      {[1,2,3,4,5,6,7,8].map((num) => (
        <section key={num} className="mt-6 space-y-4">
          <h2 className="text-lg font-semibold text-slate-900">
            {t(`legal.cookies.${num}.title`)}
          </h2>

          <p className="text-[13px] leading-relaxed">
            {t(`legal.cookies.${num}.body1`)}
          </p>

          {t(`legal.cookies.${num}.body2`, "") && (
            <p className="text-[13px] leading-relaxed">
              {t(`legal.cookies.${num}.body2`)}
            </p>
          )}

          {t(`legal.cookies.${num}.list.0`, "") && (
            <ul className="ml-5 list-disc text-[13px] leading-relaxed">
              {Array.from({ length: 10 }).map((_, index) => {
                const item = t(`legal.cookies.${num}.list.${index}`, "");
                return item ? <li key={index}>{item}</li> : null;
              })}
            </ul>
          )}
        </section>
      ))}

      {/* Contact */}
      <section className="mt-6 mb-10 space-y-4">
        <h2 className="text-lg font-semibold text-slate-900">
          {t("legal.cookies.contactTitle")}
        </h2>
        <p className="text-[13px] leading-relaxed">
          {t("legal.cookies.contactBody")}
        </p>

        <a
          href="mailto:support@cerebrumlux.com"
          className="text-teal-600 underline text-[13px]"
        >
          support@cerebrumlux.com
        </a>
      </section>
    </main>
  );
};

export default CookiesPage;
